import { render, staticRenderFns } from "./issueRiskAssessment.vue?vue&type=template&id=45ea92e0"
import script from "./issueRiskAssessment.vue?vue&type=script&lang=js"
export * from "./issueRiskAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45ea92e0')) {
      api.createRecord('45ea92e0', component.options)
    } else {
      api.reload('45ea92e0', component.options)
    }
    module.hot.accept("./issueRiskAssessment.vue?vue&type=template&id=45ea92e0", function () {
      api.rerender('45ea92e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/iei/issueRiskAssessment.vue"
export default component.exports